import { ResourceListDTO } from '../resource/resource-list.dto';
import { CalendarEventExcludedDateListDTO } from './calendar-event-excluded-date-list.dto';
import { BaseDTO } from '../global/base.dto';
import { ParticipantListDTO } from './participant-list.dto';

export class CalendarEventDTO extends BaseDTO {

    type: number;

    title: string;

    description: string;

    location: string;

    start: string | Date;

    end: string | Date;

    allDay: boolean;

    recurrence: string;

    duration: number;

    publicHoliday: boolean;

    allowance: number;

    pending: boolean;

    excludedDates: Array<CalendarEventExcludedDateListDTO>;

    participants: Array<ParticipantListDTO>;

    resources: Array<ResourceListDTO>;

}
